export const API = import.meta.env.VITE_APP_BASE_URL;
export const API_EMAIL_VALIDATION = import.meta.env
  .VITE_APP_EMAIL_VALIDATION_URL;
